export const COMPONENT_CARD_WIDTH_CATALOGUE = [208, 432, 880];
export const COMPONENT_CARD_HEIGHT = 160;
export const COMPONENT_CARD_PADDING = 16;

export const SMALL_COMPONENT_CARD_WIDTH = 96;
export const SMALL_COMPONENT_CARD_HEIGHT = 72;
